import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { postRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const AddServices = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('active');
  const [serviceFile, setServiceFile] = useState(null);
  const [videoUrl, setVideoUrl] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('status', status);
    if (videoUrl.trim()) {
      formData.append('videoUrl', videoUrl.trim());
    }
    if (serviceFile) {
      formData.append('image', serviceFile);
    }

    try {
      await postRequest('services', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success('Service added successfully!', {
        position: 'top-right',
        autoClose: 2000
      });
      setTimeout(() => {
        navigate('/services');
      }, 2000);
    } catch (error) {
      console.error('Failed to add service:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Add Service</h4>
      </div>
      <div className="mx-4">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="admin-label" htmlFor="service-title">Title</label>
            <input
              id="service-title"
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter service title"
              required
            />
          </div>
          <div className="form-group">
            <label className="admin-label" htmlFor="service-desc">Description</label>
            <textarea
              id="service-desc"
              className="form-control"
              rows="4"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter service description"
              required
            />
          </div>
          <div className="form-group">
            <label className="admin-label" htmlFor="service-status">Status</label>
            <select
              id="service-status"
              className="form-control"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>
          <div className="form-group">
            <label className="admin-label" htmlFor="service-video-url">
              Video URL (optional)
            </label>
            <input
              id="service-video-url"
              type="url"
              className="form-control"
              value={videoUrl}
              onChange={(e) => setVideoUrl(e.target.value)}
              placeholder="Enter video link (optional)"
            />
          </div>
          <div className="form-group">
            <label className="admin-label" htmlFor="service-file">Choose Image</label>
            <input
              id="service-file"
              type="file"
              className="form-control"
              onChange={(e) => setServiceFile(e.target.files?.[0] || null)}
              required
            />
          </div>
          <button type="submit" className="btn addbtn">
            Save
          </button>
        </form>
        {serviceFile ? (
          <p className="mt-3">Selected: {serviceFile.name}</p>
        ) : null}
      </div>
    </div>
  );
};

export default AddServices;
